import React from 'react';
import PropTypes from 'prop-types';
import { PROP_ADDRESS, getListItemShape } from 'redux/models/offices/model';
import Button from 'theme/components/Button/Button';
import { MarkerIcon } from 'theme/components/Icons/Icons';
import Styles from './OfficePageList.scss';

const OfficePageListItem = ({ item, chooseItem, isChosen }) => (
  <div className={Styles.listItem}>
    <div className={Styles.listItemBase}>
      <MarkerIcon className={Styles.listItemIcon} />
      <p className={Styles.listItemText}>{item[PROP_ADDRESS]}</p>
    </div>
    <div className={Styles.listItemBtn}>
      <Button onClick={() => chooseItem(item)} isActive={isChosen}>
        {isChosen ? 'Выбран' : 'Выбрать'}
      </Button>
    </div>
  </div>
);

OfficePageListItem.propTypes = {
  isChosen: PropTypes.bool,
  chooseItem: PropTypes.func,
  item: getListItemShape(),
};

export default OfficePageListItem;
